<template>
  <div>
    <div class="ant-modal-root order-detail_loader" v-if="fetching">
      <div class="ant-modal-mask">
        <div
          class="ant-modal-wrap d-flex justify-content-center align-items-center"
        >
          <a-spin></a-spin>
        </div>
      </div>
    </div>

    <a-modal
      v-if="order"
      :visible="!!order"
      @change="back"
      class="order-detail_modal"
      :footer="false"
    >
      <template #title>
        <div class="font-weight-bold">
          {{ order.order_id }}
        </div>
        <div class="small mb-n2">
          <span class="text-muted">
            {{ $moment(order.order_date).format('DD MMMM YYYY HH:mm') }}
          </span>
        </div>
      </template>

      <div class="row">
        <div class="col-sm-6 mb-3">
          <h5>Customer Info</h5>

          <dl class="">
            <dt class="col-sm-3">Name</dt>
            <span v-if="order.customer_info.name.indexOf('null') > -1">
            <dd class="col-sm-8">{{ order.customer_info.name.slice(0, -4) }}</dd>
            </span>
            <span v-else>
            <dd class="col-sm-8">{{ order.shipping_info.name }}</dd>
            </span>
            <dt class="col-sm-3">Phone</dt>
            <dd class="col-sm-8">{{ order.customer_info.phone }}</dd>

            <dt class="col-sm-3">Email</dt>
            <dd class="col-sm-8">{{ order.customer_info.email }}</dd>
          </dl>
        </div>

        <div class="col-sm-6 mb-3">
          <h5>Payment Information</h5>

          <dl>
            <dt>Total Payment</dt>
            <dd>{{ order.payment_info.gross_amount | currency }}</dd>

            <dt>Payment Status</dt>
            <dd>{{ order.payment_info.payment_status }}</dd>

            <dt>Payment Method</dt>
            <dd>
              <div>
                {{ order.payment_info.payment_method }}
              </div>
              <div>
                {{ order.payment_info.va_number }}
              </div>
            </dd>
          </dl>
        </div>

        <div class="col-sm-12" v-if="app.name !== 'dompetdhuafa'">
          <h5 class="">Shipping Information</h5>

          <div class="mb-1">
            <strong>{{ order.shipping_info.name }}</strong>
          </div>
          <div>
            {{ String(order.shipping_info.address).trim() }}
          </div>
          <div>
            {{
              [
                order.shipping_info.sub_district,
                order.shipping_info.district,
                order.shipping_info.city,
                order.shipping_info.province,
              ].join(', ')
            }}
          </div>
          <div>{{ order.shipping_info.country }} - {{ order.shipping_info.postal_code }}</div>
          <div>{{ order.shipping_info.phone }}</div>

          <div class="mt-1 font-weight-bold">
            {{ order.shipping_info.logistic.name }} {{ order.shipping_info.logistic.service }}
          </div>
        </div>

        <div class="col-sm-12 mt-5">
          <h5 class=""> Seller Information </h5>

          <dt> CHANNEL </dt>
          <dd>{{ order.channel_name }}</dd>

          <template v-if="order.seller_info.store_name">
            <dt> STORE NAME </dt>
            <dd>{{ order.seller_info.seller }}</dd>
          </template>

          <template v-if="order.seller_info.first_name">
            <dt> STORE OWNER </dt>
            <dd>{{ order.seller_info.first_name }}</dd>
          </template>

          <template v-if="order.seller_info.seller_email">
            <dt> EMAIL </dt>
            <dd>{{ order.seller_info.seller_email }}</dd>
          </template>

          <template v-if="order.seller_info.seller_phone">
            <dt> PHONE </dt>
            <dd>{{ order.seller_info.seller_phone }}</dd>
          </template>
<!-- menampilkan nama pekurban khusus untuk client dompet dhuafa jika ordernya berupa kurban -->
          <template>
          <h5 class=" mt-3"> Keterangan </h5>
          <div class="col-sm-6 mx-0 px-0" v-if="app.name === 'dompetdhuafa'">
            <div v-for="item in order.order_items" :key="item.uuid">
                  <div v-if="item.product_title.toLowerCase().includes('kurban') || item.product_title.toLowerCase().includes('qurban') ">
                  <dt> NAMA PEKURBAN </dt>
                  <dd>   {{ String(order.shipping_info.address).trim() }}</dd>
                </div>
                 <div v-else-if="item.product_title.toLowerCase().includes('kurban') === false && order.order_items.length <=1 ">
                   <dt> NOTE </dt>
                <dd>   {{ String(order.shipping_info.address).trim() }}</dd>
                </div>
                 <!-- <div v-else-if="item.product_title.toLowerCase().includes('wakaf') && order.order_items.length <=1 || item.product_title.toLowerCase().includes('zakat') && order.order_items.length <=1 ">
                   <dt> CATATAN </dt>
                <dd>   {{ String(order.shipping_info.address).trim() }}</dd>
                </div> -->
                 <div v-else>
                </div>
            </div>
          </div>
                <div v-else>
                <dt> NOTE </dt>
                <dd>   {{ String(order.shipping_info.address).trim() }}</dd>
                </div>

          </template>

        </div>
      </div>

      <div class="order-detail__items">
        <div class="order-detail__items__header">
          <div class="">Product name</div>
          <!-- <div class="d-none d-sm-table-cell">Price</div> -->
          <div class="order-detail__items__header__amount">Amount</div>
        </div>
        <div
          v-for="item in order.order_items"
          :key="item.uuid"
          class="order-detail__items__item"
        >
          <div>
            <div class="media">
              <img :src="`${item.image_url}`" class="mr-3 img-thumbnail" />
              <div class="media-body">
                <div class="font-weight-bold">{{ item.product_title }}</div>
                <div class="text-muted small mt-2">
                  <div>SKU: {{ item.sku }}</div>
                </div>
                <div v-if="Number(item.discount)">
                  <div style="text-decoration: line-through;"> {{ item.price | currency }} </div>
                  <div class="text-muted"> Discount {{ Number(item.discount) | currency }} </div>
                </div>
                <div class="text-muted small">
                  <div>Qty: {{ item.qty }} X {{ Number(item.item_sellingprice) * item.qty | currency }} </div>
                </div>
                <div class="text-muted small mt-2" v-if="item.voucher_value && item.voucher_code">
                  <div> Voucher: </div>
                  <div class="d-flex flex-row">
                    <strong> {{ item.voucher_code }}: </strong>
                    <div class="ml-3" style="color: red"> - {{ item.voucher_value | currency }} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {{ (Number(item.item_sellingprice) * item.qty) - (item.voucher_value) | currency }}
          </div>
        </div>
      </div>

      <dl class="row mt-3">
        <dt class="col-6">
          Total Item Price
        </dt>
        <dd class="col-6 text-right">
          {{ totalItemPrice | currency }}
        </dd>

        <dt class="col-6">
          Shipping Cost
        </dt>
        <dd class="col-6 text-right">
          {{ shippingCost | currency }}
        </dd>

        <dt class="col-6">
          Insurance Cost
        </dt>
        <dd class="col-6 text-right">
          {{ insuranceCost | currency }}
        </dd>

        <dt class="col-6 text-danger" v-if="discount > 0">
          Discount
        </dt>
        <dd class="col-6 text-danger text-right"  v-if="discount > 0">
          {{ order.discount | currency }}
        </dd>

        <dt class="col-6" v-if="voucher.status">
          Voucher
        </dt>
        <dd class="col-6 text-danger text-right"  v-if="voucher.status">
          - {{ order.voucher_value | currency }}
        </dd>

        <dt class="col-6">
          Total
        </dt>
        <dd class="col-6 text-right font-weight-bold">
          {{ total | currency }}
        </dd>
      </dl>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      fetching: true,
      order: null,
    }
  },
  computed: {
    ...mapState(['app']),
    totalItemPrice() {
      return !this.order ? 0 : this.order.order_items.reduce((acc, item) => {
        return acc + ((Number(item.item_sellingprice) * item.qty) - item.voucher_value)
      }, 0)
    },
    shippingCost() {
      return Number(this.order?.shipping_info?.logistic?.cost | 0)
    },
    insuranceCost() {
      return Number(this.order?.shipping_info?.logistic?.insurance_cost | 0)
    },
    discount() {
      return Number(this.order?.discount | 0)
    },
    total() {
      return this.totalItemPrice + this.shippingCost + this.insuranceCost - this.discount - this.voucher.value
    },
    voucher() {
      // eslint-disable-next-line
      return this.order?.voucher_value && this.order?.voucher_list ? {
        status: true,
        value: this.order.voucher_value,
      } : {
        status: false,
        value: this.order.voucher_value,
      }
    },

  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, this.$parent.position.y || 0)
      document.querySelector('body').style.overflow = 'hidden'
    })

    this.getOrder()
  },
  beforeDestroy() {
    document.querySelector('body').style.overflow = 'auto'
  },
  watch: {
    order() {
      this.$nextTick(() => {
        const modal = document.querySelector('.order-detail_modal')

        if (modal) {
          const header = modal.querySelector('.ant-modal-header')
          const body = modal.querySelector('.ant-modal-body')
          const height = header.offsetHeight || 0

          body.style.maxHeight = `calc(100vh - ${height}px)`
        }
      })
    },
  },
  methods: {
    getOrder() {
      this.$store
        .dispatch('salesOrders/GETORDERDETAIL', this.$route.params.id)
        .then(
          (response) => {
            // console.log(response)
            if (response.status !== 200) {
              return this.back()
            }
            this.order = response.data.data
          },
          (err) =>
            this.$message.error(err?.response?.message?.data || err?.message),
        )
        .finally(() => {
          this.fetching = false
        })
    },
    back() {
      this.$router.push({
        name: 'orders.index',
      })

      this.$nextTick(() => {
        document.querySelector('body').style.overflow = 'auto'
        window.scrollTo(0, this.$parent.position.y || 0)
      })
    },
  },
}
</script>

<style lang="scss">
.order-detail_loader {
  .ant-spin-dot-item {
    background-color: #fff;
  }
}

.order-detail_modal {
  .ant-modal {
    margin: 0 0 0 auto !important;
    top: 0;
    padding-bottom: 0;

    &-content {
      height: 100vh;
      border-radius: 0;
    }

    &-body {
      overflow: auto;
    }
  }

  h5 {
    font-size: .9rem;
    color: #999;
    text-transform: uppercase;
  }
  dl {
    align-items: flex-start;

    dt,
    dd {
      padding-top: .3rem;
      padding-bottom: .3rem;
      margin-bottom: 0;
    }

    dt {
      text-transform: uppercase;
      font-size: 90%;
      line-height: 1.25;
    }

    &:not(.row) {
      dt,
      dd {
        padding: 0;
      }

      dd {
        margin-bottom: .5rem;
      }
    }
  }

}

.order-detail__items {
  margin-top: 3rem;
  display: table;

  &__header {
    display: table-header-group;

    > *  {
      display: table-cell;
      text-transform: uppercase;
      font-weight: 300;
      padding: .5rem;
      font-size: 85%;
      background: #f0f2f4;
    }

    &__amount {
      padding-right: 3.5rem !important;
    }
  }

  &__item {
    display: table-row;
    margin-left: -1rem;
    margin-right: -1rem;
    width: 100%;

    > div {
      display: table-cell;
      vertical-align: top;
      padding: .5rem .5rem;
      border-bottom: 1px solid #efefef;
      width: 100%;
    }
  }

  .media {
    img {
      max-width: 75px;
      width: 100%;
    }
  }
}
</style>
